import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { createNotification, getNotifications, getNotificationsFulfilled } from './notifications_thunk';

const initialState = {
  notifications: [],
  status: '',
  message: ''
}

export const methodsSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    clearNotiState: (state) => {
      state.authState = '';
      state.status = '';
      state.message = ''
    },
  },
  extraReducers: {
    [createNotification.pending]: asyncIsPending,
    [createNotification.rejected]: asyncIsRejected,
    [createNotification.fulfilled]: asyncIsFulfilled,
    [getNotifications.pending]: asyncIsPending,
    [getNotifications.rejected]: asyncIsRejected,
    [getNotifications.fulfilled]: getNotificationsFulfilled
  }
});

export const { clearNotiState } = methodsSlice.actions;
export default methodsSlice.reducer;